import styles from './track.module.css';

function Track(props) {

  const renderAction = () => {
    // If the isRemove prop is true, render a remove button. Otherwise, render an add button.
    if (props.isRemove) {
      return (
        <button className={styles.removeButton} onClick={handleClick}>-</button>
      );
    } else {    
      return (
        <button className={styles.addButton} onClick={handleClick}>+</button>
      );
    }
  }

  const handleClick = () => {
    // If the isRemove prop is true, call the onRemove prop. Otherwise, call the onAdd prop.
    if (props.isRemove) {
      props.onRemove(props.track);
    } else {    
      props.onAdd(props.track);
    }
  }

  return (
    <div className={styles.Track} >
        {/* Display the track name, artist, and album. */}
        <div className={styles.Song}>
          <span className={styles.TrackName}>{props.track && props.track.name}</span>
          <span className={styles.Artist}>{props.track && props.track.artist}</span>
        </div>
        {/* // Display an add or remove button dependent on the isRemove prop */}
        {renderAction()}
    </div>
  );
}

export default Track;
